define('commons/device-location-map',['jquery', 'commons/coverage-map', 'utils/application-data'], function($, CoverageMap, appData) {
    /**
     * <pre>
     * markerInfo = {
     *      CoverageMap.marketInfo,
     *      name: device's name,
     *      hexId: device's id in hexadecimal,
     *      comStateString: the device communication status or signal depends on active mode,
     *      lastCom: the device last communication date
     *      
     * }
     * </pre>
     */
    var DeviceLocationMap = function(mapNodeId, options) {
        var opts = {
            showSlider: false
        };
        $.extend(opts, options);
        // Call the inherited coverage map constructor
        CoverageMap.call(this, mapNodeId, opts);
    };

    // Inherit from CoverageMap
    for ( var element in CoverageMap.prototype) {
        DeviceLocationMap.prototype[element] = CoverageMap.prototype[element];
    }

    DeviceLocationMap.prototype._getInfoContent = function(markerInfo) {
        return '<p><a href="/device/' + markerInfo.id + '">Device id: ' + markerInfo.hexId + '</a></p>'
            + '<p>Name: ' + markerInfo.name + '</p>'
            + '<p>Last message: ' + markerInfo.lastCom + '</p>'
            + '<p>Link Quality Indicator: <img class="signal-power-img link-quality-info" style="margin: -15px 5px -5px 10px;" title="' + markerInfo.linkQuality + '" src="/resources/img/signal/' + markerInfo.signalStrength + '.png?v=' + appData.version + '"/></p>'
            + '<p>Lat: ' + markerInfo.lat + '</p>'
            + '<p>Lng: ' + markerInfo.lng + '</p>';
    };

    return DeviceLocationMap;
});
